import { HelpCircle } from "lucide-react";
import { useEffect } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLang } from "@/i18n/LanguageContext";

const FAQ_KEYS = ["q1", "q2", "q3", "q4", "q5", "q6"];

export const FaqSection = () => {
  const { t } = useLang();

  // FAQPage structured data for Google rich results
  useEffect(() => {
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQ_KEYS.map((k, i) => ({
        "@type": "Question",
        name: t(`faq.${k}`),
        acceptedAnswer: { "@type": "Answer", text: t(`faq.a${i + 1}`) },
      })),
    };
    let el = document.getElementById("faq-jsonld");
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = "faq-jsonld";
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(jsonLd);
    return () => el.remove();
  }, [t]);

  return (
    <section
      id="faq"
      className="py-16 sm:py-24 px-4 sm:px-6 bg-[#0a0a0a]"
      data-testid="faq-section"
    >
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 sm:mb-14">
          <div className="inline-flex items-center gap-2 text-indigo-400 font-medium tracking-widest uppercase text-xs sm:text-sm mb-3 sm:mb-4">
            <HelpCircle className="w-4 h-4 sm:w-5 sm:h-5" />
            <span>{t("faq.eyebrow")}</span>
          </div>
          <h2 className="section-title text-2xl sm:text-3xl lg:text-4xl">{t("faq.title")}</h2>
          <p className="text-zinc-500 max-w-xl mx-auto mt-3 sm:mt-4 text-sm sm:text-base">
            {t("faq.subtitle")}
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQ_KEYS.map((k, i) => (
            <AccordionItem
              key={k}
              value={k}
              className="glass rounded-xl border border-white/10 px-5 sm:px-6"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                className="text-left text-sm sm:text-base font-semibold text-zinc-100 hover:no-underline py-4 sm:py-5"
                data-testid={`faq-trigger-${i}`}
              >
                {t(`faq.${k}`)}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 text-sm sm:text-base leading-relaxed pb-5">
                {t(`faq.a${i + 1}`)}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FaqSection;
